























































































import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { Popup } from '@/shared/models/view/popup-viewmodel';
import { Config } from '../models/config-viewmodel';
import { IDictionary } from '@/shared/models/interface/dictionary-model';
import { Study } from '../models/grade-viewmodels';

@Component({
    name: 'ExportDialog',
    computed: {
        ...mapState(['config']),
        ...mapState('root', ['popupComponent']),
        ...mapGetters('root', ['label']),
        ...mapGetters(['noExcurStudy', 'excurStudy'])
    }
})
export default class ExportDialog extends Vue {
    public popupComponent!: Popup;
    public exportType: any = 'pdf';
    public includeFailedGrades: boolean = false;
    public includePartialGrades: boolean = false;
    public selectedStudies: IDictionary<boolean> = {};
    public config!: Config;

    private labelModule = 'ModuleOverview';

    private getStudyList(): Study[] {
        if (this.$store.getters.noExcurStudy && this.$store.getters.excurStudy) {
            return [...this.$store.getters.noExcurStudy, this.$store.getters.excurStudy];
        }

        return this.$store.getters.noExcurStudy || [this.$store.getters.excurStudy] || [];
    }

    private closePopup(): void {
        this.$store.dispatch('root/closePopup');
    }

    private constructExportLink(): string {
        let host = '/api/students';
        let type = 'grades/' + this.exportType;
        let vuNetId = this.config.vuNetIdStudent;
        let language = this.config.language;
        let checkedStudies = Object.entries(this.selectedStudies).filter(([key, value]) => value).map(([key, value]) => key);
        if (checkedStudies.length == 0) return '';
        let checkedStudiesUri = '/' + checkedStudies.join(',');

        // /webapi/api/study/gradesPDF/iuk300/NL/false/false/50051121 (PDF)
        return `${host}/${type}/${vuNetId}/${language}/${this.includeFailedGrades}/${this.includePartialGrades}${checkedStudiesUri}`;
    }
}
